import React from 'react';
import { Icon } from '@contently/toolkit';
import styled from '@emotion/styled';

const StyledIcon = styled(Icon)`
  width: 100%;
  margin: auto;
  padding: 50px;
`;

const LoadingSpinner = () => <StyledIcon type="spinner" spin="clockwise" />;

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./app/javascript/utils/shared/LoadingSpinner.jsx